const POWER_FIELDS = ['right_sph', 'left_sph', 'right_cyl', 'left_cyl', 'right_axis', 'left_axis'];

const normalize = value => {
  if (value === null || value === undefined || value === '') return null;
  const number = Math.round(parseFloat(value) * 100) / 100;
  return isNaN(number) || number === 0 ? null : number;
};

const same = (a, b) => {
  const na = normalize(a);
  const nb = normalize(b);
  if (na === null || nb === null) return na === nb;
  return Math.abs(na - nb) < 0.01;
};

const nearAdd = (prescription, eye) => {
  const adds = prescription.spectacles || prescription;
  return adds[`${eye}_near_add`] || adds.add_near;
};

const sameSpectaclePrescription = (entered, existing) =>
  POWER_FIELDS.every(field => same(entered[field], existing[field])) &&
  same(nearAdd(entered, 'right'), nearAdd(existing, 'right')) &&
  same(nearAdd(entered, 'left'), nearAdd(existing, 'left'));

// Newest live spectacle prescription of the customer with the same powers as the one being
// entered, or null. Rows the customer deleted on the website are not counted (DP-4856).
export default function findDuplicatePrescription(entered, prescriptions) {
  return (
    [...prescriptions]
      .filter(p => p.type_id == 1 && !p.customer_deleted_at)
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .find(p => sameSpectaclePrescription(entered, p)) || null
  );
}
